/**
 * Loading state constants
 */
export function VitalityLoadingState() {}
VitalityLoadingState.ERROR = 0;
VitalityLoadingState.FETCHING = 1;
VitalityLoadingState.WORKING = 2;
VitalityLoadingState.READY = 3;

export default {
  VitalityLoadingState,
}
